(() => {
  const PRODUCT_MAIN_SELECTOR = 'main[data-template*="product"]';
  const STOCK_MESSAGE_PATTERN = /^こちらの商品は残り\s*\d+\s*点です[。.]?$/;
  const DIRECT_ERROR_SELECTORS = [
    '.product-form-text__error',
    '[ref="addToCartTextError"]',
    '[role="status"]',
    '[aria-live]'
  ].join(',');
  const IGNORED_TEXT_NODE_ANCESTORS = 'script, style, noscript, svg, button, input, select, textarea, option';

  const normalizeText = (text) => text.replace(/\s+/g, ' ').trim();
  const isStockLeftMessage = (text) => STOCK_MESSAGE_PATTERN.test(normalizeText(text));

  const hideElement = (element) => {
    if (!(element instanceof HTMLElement)) return;

    element.textContent = '';
    element.hidden = true;
    element.setAttribute('aria-hidden', 'true');
    element.setAttribute('data-chatgpt-stock-message-hidden', 'true');
    element.classList.add('hidden');
    element.style.setProperty('display', 'none', 'important');
    element.style.setProperty('visibility', 'hidden', 'important');
    element.style.setProperty('height', '0', 'important');
    element.style.setProperty('min-height', '0', 'important');
    element.style.setProperty('margin', '0', 'important');
    element.style.setProperty('padding', '0', 'important');
    element.style.setProperty('overflow', 'hidden', 'important');
  };

  const getHideTarget = (element) => {
    return element.closest(DIRECT_ERROR_SELECTORS) || element;
  };

  const hideDirectErrorMessages = (main) => {
    const nodes = main.querySelectorAll(DIRECT_ERROR_SELECTORS);

    for (const node of nodes) {
      if (!(node instanceof HTMLElement)) continue;
      if (!isStockLeftMessage(node.textContent || '')) continue;

      hideElement(node);
    }
  };

  const hideMatchingTextNodes = (main) => {
    const walker = document.createTreeWalker(main, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;
        if (!parent || parent.closest(IGNORED_TEXT_NODE_ANCESTORS)) {
          return NodeFilter.FILTER_REJECT;
        }

        return isStockLeftMessage(node.textContent || '') ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });

    const textNodes = [];
    let currentNode = walker.nextNode();
    while (currentNode) {
      textNodes.push(currentNode);
      currentNode = walker.nextNode();
    }

    for (const textNode of textNodes) {
      const parent = textNode.parentElement;
      if (!parent) continue;

      hideElement(getHideTarget(parent));
    }
  };

  const hideStockMessages = () => {
    const main = document.querySelector(PRODUCT_MAIN_SELECTOR);
    if (!(main instanceof HTMLElement)) return;

    hideDirectErrorMessages(main);
    hideMatchingTextNodes(main);
  };

  const start = () => {
    let pending = false;
    const scheduleHideStockMessages = () => {
      if (pending) return;
      pending = true;
      requestAnimationFrame(() => {
        pending = false;
        hideStockMessages();
      });
    };

    hideStockMessages();

    const observeTarget = document.querySelector(PRODUCT_MAIN_SELECTOR) || document.body;
    if (!observeTarget) return;

    const observer = new MutationObserver(scheduleHideStockMessages);
    observer.observe(observeTarget, {
      childList: true,
      subtree: true,
      characterData: true
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
